import {
  CompletePaymentRequest,
  CompletePaymentSuccessResponse,
  PaymentTypeACH,
  StartPaymentRequest,
  StartPaymentSuccessResponse,
  TransactionDetails
} from '@cms-max/medicare-api-sdk'
import { rest } from 'msw'
import { isTest } from 'test-utils/isTest'
import { coreApiBase } from 'test-utils/mock-api'

const startPaymentSuccessResponse: StartPaymentSuccessResponse = {
  tcsAppId: 'tcsAppId',
  token: 'token'
}

export function startPaymentSuccess () {
  return rest.post<StartPaymentRequest>(
    `${coreApiBase}/premiums/payments`,
    (req, res, ctx) => {
      const statusCode = req.headers.get('Accept-Language') ? 200 : 500
      return res(
        ctx.delay(isTest ? 0 : undefined),
        ctx.status(statusCode),
        ctx.json(startPaymentSuccessResponse)
      )
    }
  )
}

export function startPaymentLoading () {
  return rest.post<StartPaymentRequest>(
    `${coreApiBase}/premiums/payments`,
    (req, res, ctx) => {
      return res(
        ctx.delay(Infinity)
      )
    }
  )
}

export function startPaymentFailure () {
  return rest.post<StartPaymentRequest>(
      `${coreApiBase}/premiums/payments`,
      (req, res, ctx) => {
        return res(
          ctx.delay(isTest ? 0 : undefined),
          ctx.status(500),
          ctx.json({})
        )
      }
  )
}

const completePaymentSuccessResponse: CompletePaymentSuccessResponse = {
  isSuccess: true,
  details: {
    agencyTrackingId: 'ACHM71085010401050605',
    paymentDate: '12-25-2022 07:59:54 PM',
    paymentAmount: 250.57,
    paymentMethod: PaymentTypeACH.Ach
  }
}

type CompletePaymentSuccessArgs = {
    isSuccess?: boolean
    details?: Partial<TransactionDetails>
}
export function completePaymentSuccess (args: CompletePaymentSuccessArgs = {}) {
  return rest.put<CompletePaymentRequest>(
    `${coreApiBase}/premiums/payments`,
    (req, res, ctx) => {
      return res(
        ctx.delay(isTest ? 0 : undefined),
        ctx.status(200),
        ctx.json({
          ...completePaymentSuccessResponse,
          ...args,
          details: {
            ...completePaymentSuccessResponse.details,
            ...args.details
          }
        })
      )
    }
  )
}

export function completePaymentLoading () {
  return rest.put<CompletePaymentRequest>(
    `${coreApiBase}/premiums/payments`,
    (req, res, ctx) => {
      return res(
        ctx.delay('infinite')
      )
    }
  )
}

export function completePaymentFailure () {
  return rest.put<CompletePaymentRequest>(
      `${coreApiBase}/premiums/payments`,
      (req, res, ctx) => {
        return res(
          ctx.delay(isTest ? 0 : undefined),
          ctx.status(500),
          ctx.json({})
        )
      }
  )
}
